import { useLocation } from 'react-router';

import * as querystring from 'query-string';

import { VariantDisplayType } from '@notino/shared/__generated__/globalSPATypes';

import { IStock } from '../ProductListing/model';

import {
  getProductView_productDetailByMasterId_variants,
  getProductView_productDetailByMasterId,
} from './queries/__generated__/getProductView';

import { IProductDetailRouteParams } from './index';

const isAvailable = (
  variant: getProductView_productDetailByMasterId_variants
) => variant.stockAvailability.code !== IStock.outOfStock;

const isMaster = (variant: getProductView_productDetailByMasterId_variants) =>
  variant.attributes && variant.attributes.Master;

const isNotSample = (
  variant: getProductView_productDetailByMasterId_variants
) => (variant.attributes ? !variant.attributes.Sample : true);

export const isNotDamaged = (variant: {
  attributes: getProductView_productDetailByMasterId_variants['attributes'];
}) => (variant.attributes ? !variant.attributes.Damage : true);

const isSale = (variant: getProductView_productDetailByMasterId_variants) =>
  variant.attributes && variant.attributes.Action;

export const selectVariant = (
  variants: getProductView_productDetailByMasterId_variants[],
  params: IProductDetailRouteParams
): getProductView_productDetailByMasterId_variants | undefined => {
  if (params.variantUrl) {
    return variants.find(
      (variant) => variant.url === `/${params.productUrl}/${params.variantUrl}/`
    );
  }

  const sale = variants.find(isSale);
  if (sale) {
    return sale;
  }

  const master = variants.find(isMaster);
  if (!isAvailable(master)) {
    const noSamples = variants.filter(isNotSample);
    return (
      noSamples.filter(isNotDamaged).find(isAvailable) ||
      noSamples.find(isAvailable) ||
      master
    );
  }
  return master;
};

export const getDisplayType = (
  variantDisplayType: getProductView_productDetailByMasterId['variantDisplayType']
): VariantDisplayType => {
  let displayType: VariantDisplayType = VariantDisplayType.Tiles;
  if (variantDisplayType && variantDisplayType !== VariantDisplayType.Default) {
    displayType = variantDisplayType;
  }
  return displayType;
};

export const useAppendDisplayTypeForAbTest = (url: string) => {
  const location = useLocation();
  const {
    query: { displayType },
  } = querystring.parseUrl(location.search);

  return `${url}?${querystring.stringify({ displayType })}`;
};

export const useAbTestDisplayType = (
  product: getProductView_productDetailByMasterId
): VariantDisplayType => {
  const location = useLocation();
  const {
    query: { displayType },
  } = querystring.parseUrl(location.search);
  const originalDisplayType = getDisplayType(product.variantDisplayType);

  switch (displayType) {
    case 'Drawer':
      return VariantDisplayType.ShadesDrawer;
    case 'Select':
      return VariantDisplayType.Select;
  }

  return originalDisplayType;
};

export const youtubeIframe = (videoId: string, autoplay = false) => `
  <iframe
    width="560"
    height="315"
    src="https://www.youtube.com/embed/${videoId}?rel=0&amp;showinfo=0&amp;iv_load_policy=3&amp;autoplay=${
  autoplay ? 1 : 0
}"
    frameborder="0"
    allow="autoplay; encrypted-media"
    allowfullscreen
  ></iframe>`;
